import moment from 'moment'

type SubscriptionCreatedAtSource = {
  createdAt?: string
  createdDate?: string
  createDate?: string
  createTimeStamp?: string
  dateCreated?: string
}

export const getSubscriptionCreatedAt = (
  subscription?: SubscriptionCreatedAtSource | null
): string | undefined =>
  subscription?.dateCreated ||
  subscription?.createdAt ||
  subscription?.createdDate ||
  subscription?.createDate ||
  subscription?.createTimeStamp

export const getCheckDate = (
  _subscriptionCreatedAt?: string
): {
  msg0: string
  msg1?: string
  startOfMonth: string
  nextMonth?: string
  endOfNextMonth?: string
  endOfMonth?: string
} => {
  const now = moment()
  const _startOfMonth = now.clone().startOf('month').format('MM-DD-YYYY')
  const _nextMonth = now
    .clone()
    .add(1, 'months')
    .startOf('month')
    .format('MM-DD-YYYY')
  const _endOfMonth = now.clone().endOf('month').format('MM-DD-YYYY')
  const _endOfNextMonth = now
    .clone()
    .add(1, 'months')
    .endOf('month')
    .format('MM-DD-YYYY')
  const cutoffDate = now.clone().date(7).format('MM-DD-YYYY')
  const msg0 =
    now.date() > 7
      ? 'Cancellation will be processed now.'
      : `Cancellation requests made on or before ${cutoffDate} are processed on ${cutoffDate}.`

  return {
    msg0,
    msg1: `Please clear out unit by ${_endOfMonth}`,
    startOfMonth: _startOfMonth,
    nextMonth: _nextMonth,
    endOfNextMonth: _endOfNextMonth,
    endOfMonth: _endOfMonth,
  }
}
